export enum InventoryTypeEnum {
  Sale = 'Sale',
  ReQuote = 'ReQuote',
  SaleCancellation = 'SaleCancellation',
  Purchase = 'Purchase',
  Build = 'Build',
  BuildConsumption = 'BuildConsumption',
  Destruct = 'Destruct',
  Adjustment = 'Adjustment',
  Initialize = 'Initialize',
  Logistic = 'Logistic',
  PurchaseCancellation = 'PurchaseCancellation',
  LogisticCancellation = 'LogisticCancellation',
  SalesReturn = 'SalesReturn',
}
